import gql from 'graphql-tag';

export const getAvailableClaims = gql`
  query getAvailableClaims {
    getAvailableClaims {
      id
      name
    }
  }
`;
